<template>
  <ModalRoot :closeByClickingOutside="true" @close="$emit('close')" class="modal-dialog--small">
    <div class="session__modal">
      <Icon class="session__modal--icon" :icon="icon" />
      <div class="session__modal--heading">
        <h1>{{ heading }}</h1>
        <hr>
      </div>
      <div class="session__modal--body">
        <p v-html="body" />
      </div>
      <div class="session__modal--footer">
        <button @click="$emit('click')">
          {{ buttonText }}
          <span class="icon-wrapper"><Icon icon="v" /></span>
        </button>
      </div>
    </div>
  </ModalRoot>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'
import ModalRoot from '@/components/ModalRoot'

@Component({
  components: {
    ModalRoot,
    Icon,
  },
  props: {
    heading: {
      type: String,
      required: false,
      default: () => '',
    },
    body: {
      type: String,
      required: false,
      default: () => '',
    },
    buttonText: {
      type: String,
      required: false,
      default: () => '',
    },
    icon: {
      type: String,
      required: false,
    },
  },
})
export default class SessionModal extends Vue {

}
</script>

<style lang="scss" scoped>
.session__modal {
  background-color: #fff;
  padding: 25px 23px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 51px);

  @include mediaFluid(tablet) {
    height: auto;
  }

  @include mediaFluid(desktop) {
    padding: 53px 68px 60px;
  }

  &--heading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 38px;
    color: #005CA9;
    text-align: center;

    hr {
      width: 46px;
      height: 6px;
      background-color: #005CA9;
      margin: 0 auto;
      border: 0;

      @include mediaFluid(desktop) {
        width: 54px;
      }
    }

    h1 {
      font-size: 2em;
      font-weight: bold;
      font-family: 'Gotham';
      line-height: 32px;
      text-transform: uppercase;
      max-width: 350px;
      margin: 30px auto 7px;

      @include mediaFluid(desktop) {
        font-size: 2.6em;
        max-width: none;
      }
    }
  }

  &--body {
    color: #535353;
    text-align: center;
    font-family: 'Gotham Book';
    font-weight: normal;
    font-size: 1em;
    line-height: 20px;
    margin: 36px auto 41px;
  }

  &--footer {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #fff;
    background-color: #009FEA;
    width: 100%;
    max-width: 280px;

    button {
      width: 100%;
      border: none;
      border-radius: 0;
      text-transform: uppercase;
      font-size: 12px;
      font-family: 'Gotham';
      font-weight: bold;
      background: transparent;
      padding: 11px 14px;      
      color: #fff;
      cursor: pointer;
    }

    .icon-wrapper {
      display: inline-block;
      margin-left: 5px;
      transform: rotate(-90deg);
    }

    .figure {
      font-size: 7px;
    }
  }

  &--icon {
    font-size: 66px;
    color: #009FEA;
  }

  .figure--session-time-out {
    margin-right: 48px;
  }

  p {
    margin: 0 auto;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/booking/SessionModal.vue